module.exports = __webpack_public_path__ + "img/01.766dbe87.png";